import styled, { useTheme } from 'styled-components';
import { ReactElement } from 'react';

import { Icon } from '@/ui/Icon';
import { Informer } from '@/ui/Informer';

const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FirstRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const TitleStyled = styled.div`
  color: ${(p) => p.theme.colors.neutral.onBackground};
  ${({ theme }) => theme.typography.title3}
`;

const SubtitleStyled = styled.div`
  ${({ theme }) => theme.typography.body1};
  color: ${(p) => p.theme.colors.neutral.onBackground};
`;

const ResultsContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding: 32px;
  width: 428px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.outline1};
`;

type RetakeLabelProps = {
  passingCriteriaMessage?: string;
  hasPassed: boolean;
  hasPassingCriteria: boolean;
  correctAnswersCount?: number;
  allQuestionsCount?: number;
  score?: number;
};

export const QuizResultsLabel = ({
  passingCriteriaMessage,
  hasPassed,
  hasPassingCriteria,
  correctAnswersCount,
  allQuestionsCount,
  score,
}: RetakeLabelProps): ReactElement => {
  const theme = useTheme();

  return (
    <ContainerStyled>
      {hasPassingCriteria && (
        <>
          <FirstRowStyled>
            {hasPassed ? (
              <>
                <Icon icon={['far', 'party-horn']} size="lg" />
                <TitleStyled>Well done - you passed!</TitleStyled>
              </>
            ) : (
              <>
                <Icon icon={['far', 'circle-x']} size="lg" />
                <TitleStyled>Try again!</TitleStyled>
              </>
            )}
          </FirstRowStyled>
          {!hasPassed && <SubtitleStyled>{passingCriteriaMessage}</SubtitleStyled>}
        </>
      )}
      <ResultsContainerStyled>
        <Informer
          label="Score"
          title={`${Math.round(score || 0)}%`}
          sideBox={{
            icon: ['far', 'bullseye-arrow'],
            iconColor: theme.tones.primary[70],
            background: theme.tones.primary[95],
            size: 'medium',
          }}
        />
        <Informer
          label="Correct answers"
          title={`${correctAnswersCount} out of ${allQuestionsCount}`}
          sideBox={{
            icon: ['far', 'bolt'],
            iconColor: theme.tones.tertiary[70],
            background: theme.tones.tertiary[95],
            size: 'medium',
          }}
        />
      </ResultsContainerStyled>
    </ContainerStyled>
  );
};
